import React, { useState } from "react";
import axios from "axios";
import bannerImage from './banner.png';

function FileUpload() {
  const [csvFile, setCsvFile] = useState(null);
  const [jsonFile, setJsonFile] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [message, setMessage] = useState("Ready.");
  const [responseData, setResponseData] = useState(null);

  const handleCsvFileChange = (event) => {
    setCsvFile(event.target.files[0]);
  };

  const handleJsonFileChange = (event) => {
    setJsonFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!csvFile || !jsonFile) {
      setMessage("Both CSV and JSON files are required.");
      return;
    }

    let jsonData = {};
    const reader = new FileReader();

    reader.onload = async () => {
      try {
        jsonData = JSON.parse(reader.result);

        const formData = new FormData();
        formData.append("jsonData", JSON.stringify(jsonData));
        formData.append("csvFile", csvFile);

        setMessage("Uploading...");

        const response = await axios.post(`${apiUrl}/API/`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.status === 200) {
          setMessage("Upload successful.");

          if (typeof response.data === "object" && "message" in response.data) {
            setResponseData(response.data.message);
            setMessage("Set response format successful.");
          } else {
            setMessage("Invalid response format.");
            setResponseData(null);
          }
        } else {
          setMessage(`Failed to upload. Status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error processing files:", error);
        setMessage(`Error: ${error.message || "An unexpected error occurred"}`);
      }
    };

    reader.readAsText(jsonFile);
  };


 // Function to Download JSON File
 const downloadJsonFile = () => {
  if (!responseData) return;

  const blob = new Blob([JSON.stringify(responseData, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");

  a.href = url;
  a.download = "response_data.json";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

  return (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <img src={bannerImage} alt="Banner" style={{ width: '50%', borderRadius: '10px' }} />
            <p></p>
            <form onSubmit={handleSubmit}>
              <label htmlFor="csvFile">Choose Engine CSV :: </label>
              <input
                id="csvFile"
                type="file"
                onChange={handleCsvFileChange}
                accept=".csv"
                style={{
                  marginTop: "10px",
                  padding: "10px",
                  border: "none",
                  cursor: "pointer",
                }}
              />
              <p></p>

              <label htmlFor="jsonFile">Choose JSON File :: </label>
              <input
                id="jsonFile"
                type="file"
                onChange={handleJsonFileChange}
                accept=".json"
                style={{
                  marginTop: "10px",
                  padding: "10px",
                  border: "none",
                  cursor: "pointer",
                }}
              />
              <p></p>

              <button type="submit"
                                style={{
                                  marginTop: "10px",
                                  padding: "10px",
                                  background: "blue",
                                  color: "white",
                                  border: "none",
                                  cursor: "pointer",
                                }}>Submit</button>
            </form>

            <p style={{ marginTop: "20px", color: "#333" }}>
              Status: {typeof message === "object" ? JSON.stringify(message) : message}
            </p>

            {/* Display Response Data as Table */}
            {responseData && (
              <div>
                <h3>Response Data:</h3>
                {/* Download Button */}
                <button
                  onClick={downloadJsonFile}
                  style={{
                    marginTop: "10px",
                    padding: "10px",
                    background: "blue",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Download Aircraft JSON
                </button>
              </div>
            )}
          </div>
  );
}

export default FileUpload;
